import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { BootstrapModalService } from '../../../../../core/services/boostrap-modal.service';

@Component({
  selector: 'app-closure-modal',
  templateUrl: './closure-modal.component.html',
  styleUrls: ['./closure-modal.component.scss'],
})
export class ClosureModalComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  agent: string = '';
  month: string = '';
  value: number = 0;
  supervisor: string = '';

  constructor(private _bsModalService: BootstrapModalService) {}

  ngOnInit(): void {
    this._bsModalService
      .getDataIssued()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data) {
          this.agent = data.agent || '';
          this.month = data.month || '';
          this.value = data.value || 0;
          this.supervisor = data.supervisor || '';
        }
      });
  }

  onSendApp(): void {
    this._bsModalService.updateDataIssued({ action: 'app' });
    this._bsModalService.updateModalClosed(true);
    this._bsModalService.updateModalClosedListener();
  }

  onSendDirect(): void {
    this._bsModalService.updateDataIssued({ action: 'direct' });
    this._bsModalService.updateModalClosed(true);
    this._bsModalService.updateModalClosedListener();
  }

  onSendClosureZG(): void {
    this._bsModalService.updateDataIssued({ action: 'zg' });
    this._bsModalService.updateModalClosed(true);
    this._bsModalService.updateModalClosedListener();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
